import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" />
      <div className="container-x py-32 text-center">
        <p className="text-7xl md:text-9xl font-bold text-aqua/30">404</p>
        <h1 className="mt-4 text-3xl md:text-4xl font-bold tracking-tight text-ink">Page not found</h1>
        <p className="mt-3 text-greyish max-w-md mx-auto">The page you're looking for doesn't exist or may have been moved.</p>
        <Link to="/" data-testid="notfound-home" className="mt-8 inline-flex items-center gap-2 bg-aqua text-white px-6 py-3.5 rounded-md font-semibold hover:bg-aqua-dark transition-all"><Home className="w-4 h-4" /> Back to Home</Link>
      </div>
    </>
  );
}
